import { render, staticRenderFns } from "./ThemeCustomizerView.vue?vue&type=template&id=7562870a&scoped=true"
import script from "./ThemeCustomizerView.vue?vue&type=script&lang=js"
export * from "./ThemeCustomizerView.vue?vue&type=script&lang=js"
import style0 from "./ThemeCustomizerView.vue?vue&type=style&index=0&id=7562870a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7562870a",
  null
  
)

export default component.exports